import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router';
// import DashboardMenu from 'components/common/DashboardMenu';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import {
  Avatar,
  Button,
  Chip,
  IconButton,
  Paper,
  // Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Stack } from '@mui/system';
import { DataGrid, GridRow } from '@mui/x-data-grid';
import { post } from 'api';
import { download } from 'api';
import { url } from 'config/config';
// import avatar6 from 'assets/images/avatar/avatar_6.webp';
import moment from 'moment';
import { enqueueSnackbar } from 'notistack';
import AddDispatch from 'components/SS/addDispatch';
import IconifyIcon from 'components/base/IconifyIcon';
import DataGridPagination from 'components/pagination/DataGridPagination';
import Ownership from 'components/sections/account/users-permissions/Ownership';

// import { DispatchProductsPopover } from './dropdownProduct';
const CustomRow = (props) => {
  const isExpanded = props.row?.isExpanded;

  return (
    <>
      {/* normal grid row */}
      <GridRow {...props} />
      {/* extra detail section below */}
      {isExpanded && (
        <Box
          sx={{
            background: '#fafafa',
            borderTop: '1px solid #eee',
            p: 2,
            ml: '0px', // aligns with row content under columns (adjust if needed)
            mr: '0px',
          }}
        >
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            Dispatch Products
          </Typography>

          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Product</TableCell>
                <TableCell>Quantity</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {props.row.dispatch?.map((item) => (
                <TableRow key={item._id}>
                  <TableCell>{item.productId?.productName}</TableCell>
                  <TableCell>{item.qnt}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      )}
    </>
  );
};

function DispatchList() {
  const { state } = useLocation();
  const [open, setOpen] = useState(false);
  const [update, setUpdate] = useState(null);
  const [dispatch, setDispatch] = useState([]);
  const [expandedRowIds, setExpandedRowIds] = useState([]);

  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 5,
  });

  const getStatusBadgeColor = (val) => {
    switch (val) {
      case 'Dispatched':
        return 'success';
      case 'Full':
        return 'success';
      case 'Hold':
        return 'error';
      case 'InProgress':
        return 'info';
      case 'Partial':
        return 'info';
      case 'no':
        return 'error';
      default:
        return 'info';
    }
  };

  const downloadPdf = async (dispatchId) => {
    try {
      const res = await download('users/dispatch_download', { id: dispatchId });

      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));

      const a = document.createElement('a');
      a.href = url;
      a.download = `dispatch-${dispatchId}.pdf`;
      a.click();

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
    }
  };

  const columns = [
    {
      field: 'expand',
      headerName: '',
      width: 60,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const isExpanded = expandedRowIds.includes(params.id);
        const toggle = (id = params.id) => {
          setExpandedRowIds(
            (prev) => (prev.includes(id) ? [] : [id]), // 👈 only one expanded
          );
        };

        return (
          <IconButton
            onClick={(e) => {
              e.stopPropagation(); // 🚀 required!
              toggle();
            }}
            size="small"
          >
            {isExpanded ? (
              <IconifyIcon icon="mdi:chevron-up" />
            ) : (
              <IconifyIcon icon="mdi:chevron-down" />
            )}
          </IconButton>
        );
      },
    },
    {
      field: 'dispatchUser',
      headerName: 'Dispatch User',
      sortable: false,
      filterable: false,
      minWidth: 240,
      flex: 1,
      renderCell: (params) => {
        const { firstName, lastName, profileImage } = params.row.dispatchUser;
        const { createdAt } = params.row;
        return (
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Avatar
              alt={firstName.toUpperCase()}
              src={`${url}${profileImage}`}
              sx={{ width: 24, height: 24 }}
            />
            <Box>
              <Typography variant="subtitle2">{`${firstName} ${lastName}`}</Typography>
              <Typography variant="caption">
                {moment(createdAt).format('DD/MM/YYYY HH:mm A')}
              </Typography>
            </Box>
          </Stack>
        );
      },
    },
    {
      field: 'status',
      headerName: 'Status',
      sortable: false,
      filterable: false,
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        const status = params?.row?.status;
        return (
          <Stack>
            <Chip
              label={status || '-'}
              variant="soft"
              color={getStatusBadgeColor(status)}
              sx={{ textTransform: 'capitalize' }}
            />
          </Stack>
        );
      },
    },
    {
      field: 'material',
      headerName: 'Material',
      sortable: false,
      filterable: false,
      minWidth: 110,
      flex: 1,
      renderCell: (params) => (
        <Stack>
          <Chip
            label={params?.row?.type || '-'}
            variant="soft"
            color={getStatusBadgeColor(params?.row?.type)}
            sx={{ textTransform: 'capitalize' }}
          />
        </Stack>
      ),
    },
    // {
    //   field: 'createAt',
    //   headerName: 'Created At',
    //   sortable: false,
    //   filterable: false,
    //   minWidth: 200,
    //   flex: 1,
    //   renderCell: (params) => {
    //     const { createdAt } = params.row;
    //     return (
    //       <Stack direction="row" alignItems="center" spacing={1.5}>
    //         <Box>
    //           <Typography variant="subtitle2">
    //             {moment(createdAt).format('DD/MM/YYYY HH:mm A')}
    //           </Typography>
    //         </Box>
    //       </Stack>
    //     );
    //   },
    // },
    {
      field: 'audit',
      headerName: 'Last Updated By',
      sortable: false,
      filterable: false,
      minWidth: 200,
      flex: 1,
      renderCell: (params) => {
        const { audit } = params.row;
        return (
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Box>
              <Typography variant="subtitle2">{`${audit?.userId.firstName} ${audit?.userId.lastName} - ${audit.action}`}</Typography>
              <Typography variant="caption">
                {moment(audit.createdAt).format('DD/MM/YYYY HH:mm A')}
              </Typography>
            </Box>
          </Stack>
        );
      },
    },
    {
      field: 'update',
      headerName: 'Update',
      sortable: false,
      filterable: false,
      minWidth: 80,
      renderCell: (params) => {
        const row = params.row;
        return (
          <IconButton
            onClick={() => {
              setUpdate(row);
              setOpen(true);
            }}
          >
            <EditOutlinedIcon />
          </IconButton>
        );
      },
    },
    {
      field: 'download',
      headerName: 'PDF',
      width: 80,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <IconButton
          onClick={async (e) => {
            e.stopPropagation();
            try {
              const blob = await downloadPdf(params.row._id);
              const url = window.URL.createObjectURL(new Blob([blob]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', `dispatch-${params.row._id}.pdf`);
              document.body.appendChild(link);
              link.click();
              link.remove();
              window.URL.revokeObjectURL(url);
            } catch (err) {
              console.error(err);
              enqueueSnackbar('Error downloading PDF', {
                variant: 'error',
              });
            }
          }}
        >
          <IconifyIcon icon="mdi:file-pdf-box" />
        </IconButton>
      ),
    },
  ];

  useEffect(() => {
    fetchDispatch();
  }, [paginationModel]);

  const fetchDispatch = async () => {
    setLoading(true);
    try {
      const res = await post('users/get_dispatch', {
        customerId: state?._id,
        page: paginationModel.page + 1,
        limit: paginationModel.pageSize,
      });
      if (res.status == 200) {
        setDispatch(res.data.data);
        setTotal(res.data.total);
      } else {
        enqueueSnackbar(res.message || 'Error while Fetching Dispatch', {
          variant: 'error',
          autoHideDuration: 3000,
        });
      }
    } catch (error) {
      enqueueSnackbar(error.message || 'Error while Fetching Dispatch', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const rowsWithExpand = useMemo(
    () =>
      dispatch.map((d) => ({
        ...d,
        isExpanded: expandedRowIds.includes(d._id),
      })),
    [dispatch, expandedRowIds],
  );

  return (
    <>
      <Paper background={1} sx={{ flex: 1, p: { xs: 3, md: 5 }, pt: { xs: 3, md: 2 } }}>
        <Ownership
          name={`${state?.firstName} ${state.lastName}`}
          email={state?.email || state?.mobile || ''}
          avatar={state?.firstName}
          lastLoginAt="2024-11-15 15:54"
          state={state}
          backto="/dispatch-managment"
        />
      </Paper>
      <Box sx={{ p: { xs: 3, md: 5 } }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: 2,
            mb: 2,
          }}
        >
          {/* <Typography sx={{ mb: 0.5 }}>InProgress</Typography> */}
          <Button variant="soft" shape="square" color="neutral" sx={{ gap: 0.5, p: 1 }}>
            <IconifyIcon icon="material-symbols:add-2-rounded" />
            <Box
              component="span"
              sx={{ display: { xs: 'none', sm: 'block' } }}
              onClick={() => setOpen(!open)}
            >
              Add Dispatch
            </Box>
          </Button>
        </Box>
        <Box sx={{ width: '100%' }}>
          <DataGrid
            loading={loading}
            rowHeight={72}
            rows={rowsWithExpand}
            columns={columns}
            getRowId={(row) => row._id}
            pagination
            paginationMode="server"
            rowCount={total}
            paginationModel={paginationModel} // { page: 0, pageSize: 10 }
            onPaginationModelChange={(e) =>
              setPaginationModel({ page: e.page, pageSize: e.pageSize })
            }
            pageSizeOptions={[5, 10, 20]}
            sx={{
              '& .margin': {
                pr: 3,
              },
              '& .MuiDataGrid-columnHeaders': {
                minWidth: '100%',
              },
            }}
            slots={{
              row: CustomRow,
              basePagination: (props) => <DataGridPagination showFullPagination {...props} />,
            }}
          />
        </Box>
      </Box>

      <AddDispatch
        open={open}
        setOpen={setOpen}
        customer={state}
        update={update}
        setUpdate={setUpdate}
        fetch={fetchDispatch}
      />
    </>
  );
}

export default DispatchList;
